import { useEffect, useRef, useState } from 'react';
import { useWiggle } from '../components/useWiggle';

type AlertLevel = 'normal' | 'warning' | 'alert' | 'critical';

/**
 * Manages wiggle animation for the widget card, triggered by critical alert level
 * or drive-off count increases.
 */
export function useWiggleAnimation(level: AlertLevel, wiggleDep?: number) {
  const [wiggleRef, wiggleTrigger, wiggling] = useWiggle<HTMLDivElement>();
  const prevWiggleDep = useRef(wiggleDep);
  const [detectedDriveOff, setDetectedDriveOff] = useState(false);
  const driveOffTimer = useRef<ReturnType<typeof setTimeout>>();

  // Use for threshold animations
  useEffect(() => {
    if (level === 'critical') {
      wiggleTrigger();
    }
  }, [level, wiggleTrigger]);

  // Used for Drive-off animations
  useEffect(() => {
    if (wiggleDep != null && prevWiggleDep.current != null && wiggleDep > prevWiggleDep.current) {
      wiggleTrigger(5000);
      clearTimeout(driveOffTimer.current);
      setDetectedDriveOff(true);
      driveOffTimer.current = setTimeout(() => setDetectedDriveOff(false), 5000);
    }
    prevWiggleDep.current = wiggleDep;

    return () => clearTimeout(driveOffTimer.current);
  }, [wiggleDep, wiggleTrigger, prevWiggleDep]);

  return { wiggleRef, wiggling, detectedDriveOff };
}
